import { createTheme } from "@mui/material";
import { APP_HEADER_HEIGHT, APP_MOBILE_HEADER_HEIGHT } from "src/layout/consts";
import palette from "./palette";
import typography from "./typography";
import shadows from "./shadows";

const theme = createTheme();
export default createTheme({
  palette,
  typography,
  breakpoints: {
    desktop: 1920
  },
  mixins: {
    toolbar: {
      [theme.breakpoints.down("sm")]: {
        minHeight: APP_MOBILE_HEADER_HEIGHT
      },
      [theme.breakpoints.up("sm")]: {
        minHeight: APP_HEADER_HEIGHT
      },
      backgroundColor: "#ffffff"
    }
  },
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          background: palette.system[700]
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          ":hover": {
            backgroundColor: palette.tertiary[300],
            borderColor: palette.secondary[500]
          }
        }
      }
    },
    MuiMenu: {
      styleOverrides: {
        list: {
          padding: "0px"
        },
        paper: {
          padding: "8px"
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          padding: "8px 12px",
          fontSize: "14px"
        }
      }
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          boxShadow: shadows[4]
        }
      }
    }
  },
  shape: {
    borderRadius: 8
  },
  shadows: [
    ...shadows,
    ...theme.shadows.slice(9)
  ]
});
